import { render, staticRenderFns } from "./bao-cao-lo-hang.vue?vue&type=template&id=206f08fd&"
import script from "./bao-cao-lo-hang.vue?vue&type=script&lang=js&"
export * from "./bao-cao-lo-hang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports